import { gql, TypedDocumentNode } from "@apollo/client";

import { ApiKey, MutationApiKeyUpdateArgs } from "types/generated";

type ApiKeyUpdate = {
  apiKeyUpdate: Pick<ApiKey, "id" | "name" | "description" | "teams" | "oidcSettings">;
};
export const UPDATE_API_KEY: TypedDocumentNode<ApiKeyUpdate, MutationApiKeyUpdateArgs> = gql`
  mutation ApiKeyUpdate($id: ID!, $input: ApiKeyUpdateInput!) {
    apiKeyUpdate(id: $id, input: $input) {
      id
      name
      description
      teams
      oidcSettings {
        clientId
        issuer
        subjectExpression
        claimMapping {
          entries {
            name
            value
          }
        }
      }
    }
  }
`;